import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=6af948bc&scoped=true&"
import script from "./pieChart.vue?vue&type=script&lang=js&"
export * from "./pieChart.vue?vue&type=script&lang=js&"
import style0 from "./pieChart.vue?vue&type=style&index=0&id=6af948bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af948bc",
  null
  
)

export default component.exports